export default "__VITE_ASSET__B$y5D1lf__"